import { Button, Col, Row, Table } from "react-bootstrap";
import { handleFieldChange } from "../../Utils";

import FieldGroup from "../../components/FieldGroup";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import React from "react";
import API from "../../services/API";

class ADKUnblocked extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            report: [],
            filters: {
                unblockedFrom: null,
                unblockedTo: null
            }
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.loadReport = this.loadReport.bind(this);
    }

    async loadReport() {
        this.setState({ loading: true, report: [] });

        const filters = Object.fromEntries(
            Object.entries(this.state.filters).filter(([ value ]) => Boolean(value))
        )

        const response = await API.ADKUnblocked.get(filters);

        this.setState({ loading: false, report: response });
    }

    render() {
        return (
            <Container loading={this.state.loading}>
                <Heading title="ADK Unblocked" />

                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="filters.unblockedFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.unblockedFrom}
                        />
                    </Col>

                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="filters.unblockedTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.unblockedTo}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg={1}>
                        <Button bsStyle="info" className="m-b-15" onClick={this.loadReport}>Load</Button>
                    </Col>
                </Row>

                <Table bordered responsive>
                    <thead>
                        <tr>
                            <td className={"fitwidth"}>Unblocked</td>
                            <td className={"fitwidth"}>Blocked</td>
                            <td>Partner ID</td>
                            <td>Affid</td>
                            <td>Subid</td>
                            <td>Country</td>
                            <td>Cost</td>
                            <td>Revenue</td>
                            <td>OnwRevenue</td>
                            <td>Total Revenue</td>
                            <td>ROI</td>
                            <td>ROI%</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.report.map(({ unblocked, blocked, partner, affid, subid, country, cost, revenue, onwRevenue, totalRevenue, roi, percentRoi }, index) => {
                                return (
                                    <tr key={index}>
                                        <td className={"fitwidth"}>{unblocked}</td>
                                        <td className={"fitwidth"}>{blocked}</td>
                                        <td>{partner}</td>
                                        <td>{affid}</td>
                                        <td>{subid}</td>
                                        <td>{country}</td>
                                        <td>{cost}</td>
                                        <td>{revenue}</td>
                                        <td>{onwRevenue}</td>
                                        <td>{totalRevenue}</td>
                                        <td>{roi}</td>
                                        <td>{percentRoi}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </Container>
        )
    }
}

export default ADKUnblocked;


// WEBPACK FOOTER //
// ./src/scenes/ADKUnblocked/index.js